import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { getVisibleYears, getVisibleYearsDesc } from "@/lib/rrhhYears";

/**
 * Devuelve el rango de años visibles según la configuración RRHH
 * (endpoint /api/rrhh/year-range). Fallback: helper local con defaults
 * (año actual − 2 .. año actual + 10) si el endpoint no está disponible.
 *
 * Uso:
 *   const { years, yearsDesc, loading } = useYearRange();
 *   <Select>{years.map(y => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</Select>
 *
 *   // Dropdown histórico con el más reciente arriba:
 *   {yearsDesc.map(y => <button key={y}>{y}</button>)}
 */
export function useYearRange() {
  const { axiosAuth } = useAuth();
  const [years, setYears] = useState(() => getVisibleYears(null));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axiosAuth().get("/rrhh/year-range");
        if (cancelled) return;
        if (Array.isArray(res.data?.years) && res.data.years.length > 0) {
          setYears(res.data.years);
        }
      } catch {
        // Mantiene fallback (defaults locales)
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [axiosAuth]);

  return {
    years,
    yearsDesc: getVisibleYearsDesc({ years }),
    loading,
  };
}
